import { q as d } from "./lib-1be19634.js";
new TextEncoder();
const i = new TextDecoder(), l = (t) => {
  const e = atob(t), o = new Uint8Array(e.length);
  for (let r = 0; r < e.length; r++)
    o[r] = e.charCodeAt(r);
  return o;
}, u = (t) => {
  let e = t;
  e instanceof Uint8Array && (e = i.decode(e)), e = e.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
  try {
    return l(e);
  } catch {
    throw new TypeError("The input to be decoded is not correctly encoded.");
  }
};
class h extends Error {
  static get code() {
    return "ERR_JOSE_GENERIC";
  }
  constructor(e) {
    var o;
    super(e), this.code = "ERR_JOSE_GENERIC", this.name = this.constructor.name, (o = Error.captureStackTrace) === null || o === void 0 || o.call(Error, this, this.constructor);
  }
}
class c extends h {
  constructor() {
    super(...arguments), this.code = "ERR_JWT_INVALID";
  }
  static get code() {
    return "ERR_JWT_INVALID";
  }
}
function p(t) {
  return typeof t == "object" && t !== null;
}
function f(t) {
  if (!p(t) || Object.prototype.toString.call(t) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(t) === null)
    return !0;
  let e = t;
  for (; Object.getPrototypeOf(e) !== null; )
    e = Object.getPrototypeOf(e);
  return Object.getPrototypeOf(t) === e;
}
const y = u;
function b(t) {
  if (typeof t != "string")
    throw new c("JWTs must use Compact JWS serialization, JWT must be a string");
  const { 1: e, length: o } = t.split(".");
  if (o === 5)
    throw new c("Only JWTs using Compact JWS serialization can be decoded");
  if (o !== 3)
    throw new c("Invalid JWT");
  if (!e)
    throw new c("JWTs must contain a payload");
  let r;
  try {
    r = y(e);
  } catch {
    throw new c("Failed to base64url decode the payload");
  }
  let n;
  try {
    n = JSON.parse(i.decode(r));
  } catch {
    throw new c("Failed to parse the decoded payload as JSON");
  }
  if (!f(n))
    throw new c("Invalid JWT Claims Set");
  return n;
}
const s = "/bossjob-api-server", _ = async ({
  redirect_uri: t,
  app_num: e = 1
}) => {
  const o = `${s}/authentication/x-auth-token?callback_url=${encodeURIComponent(t)}&app_num=${e}`;
  return fetch(o).then((r) => r.json());
}, g = async ({
  owner_key: t,
  owner_secret: e,
  oauth_verifier: o,
  app_num: r = 1
}) => {
  const n = `${s}/authentication/through-verify-get-x-user?verify=${o}&owner_key=${t}&owner_secret=${e}&app_num=${r}`;
  return fetch(n).then((a) => a.json());
}, O = async ({
  code: t,
  redirect_uri: e,
  app_num: o
}) => {
  const r = { grant_type: "authorization_code", code: t, redirect_uri: e, app_num: o };
  return fetch(`${s}/authentication/line-token`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: d.stringify(r)
  }).then((n) => n.json());
}, E = async ({
  social_type: t,
  social_user_id: e
}) => {
  const o = `${s}/authentication/check-exist-social-user?social_type=${t}&social_user_id=${e}`;
  return fetch(o).then((r) => r.json());
};
export {
  O as a,
  g as b,
  E as c,
  b as d,
  _ as f
};
//# sourceMappingURL=service-c268ddb6.js.map
